module.exports = __webpack_public_path__ + "cbe4db1984f45707ddadc0b8416da578.png";